import { ReactElement } from 'react';
import { LinkButton } from './LinkButton';

export type CardViewMoreProps = {
    title: string;
    count?: number;
    countLabel?: string;
    href?: string;
    linkLabel?: string;
};

export const CardViewMore = ({
    title,
    count,
    countLabel = 'Experiences',
    href,
    linkLabel,
}: CardViewMoreProps): ReactElement => {
    return (
        <div
            className="flex min-h-30 w-full items-center justify-between gap-4 rounded-2xl bg-sand-normal p-1.5 dark:bg-dark-3 lg:flex-row"
            data-test-id="View_more"
        >
            <div className="flex min-w-0 flex-1 flex-col justify-center px-2.5 lg:w-1/2 lg:pl-20">
                <h2 className="tx-heading-3 m-0 w-4/5 truncate py-1 text-gray-1 dark:text-white">
                    {title}
                </h2>
                {typeof count === 'number' && (
                    <span className="tx-medium-regular text-gray-2 dark:text-gray-3">
                        {count} {countLabel}
                    </span>
                )}
            </div>
            {href && linkLabel && <LinkButton href={href} label={linkLabel} />}
        </div>
    );
};
